<template>
  <div class="info__setps">
    <InfoStepsList
      v-for="(list, index) in data"
      :key="index"
      :dataList="list"
    />
  </div>
</template>

<script>
import InfoStepsList from '@/components/InfoStepsList';

export default {
  name: 'InfoSteps',

  props: ['data'],

  components: {
    InfoStepsList,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.info__setps {
  padding: 60px 40px 40px 40px;

  @include mq(sm) {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    padding: 100px 100px 100px 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoSteps.vue